export const priceListData = {
  year: "2025",
  currency: "Euro",
  vatExcluded: true,
  vatRate: 21,
  note: "ALGT reserves the right to change these prices at any time. Discounts may be applicable for large volumes.",
  deliveryFee: {
    base: 10,
    baseReports: 50,
    additionalPerReport: 0.12
  },
  categories: [
    {
      title: "Diamond Reports",
      tables: [
        {
          name: "Natural Diamond Report (loose)",
          type: "standard",
          headers: ["Carat weight", "Fee (€)"],
          rows: [
            ["≤0.29", "32"],
            ["0.30-0.49", "37"],
            ["0.50-0.99", "42"],
            ["1.00 +", "45/ct"]
          ]
        },
        {
          name: "Rough Diamond Identification Report",
          type: "standard",
          headers: ["Carat weight", "Fee (€)"],
          rows: [
            ["≤0.99", "30"],
            ["1.00 +", "30/ct"],
            ["Yield Calculation ≤0.99", "40"],
            ["Yield Calculation 1.00 +", "40/ct"]
          ]
        },
        {
          name: "Laboratory-Grown Diamond Report (loose)",
          type: "standard",
          headers: ["Carat weight", "Fee (€)"],
          rows: [
            ["Any weight", "25"]
          ]
        }
      ]
    },
    {
      title: "Colored Stone Reports",
      tables: [
        {
          name: "Ruby, Sapphire, Emerald, Alexandrite, Paraiba",
          type: "standard",
          headers: ["Carat weight", "Fee (€)"],
          rows: [
            ["≤0.49", "30"],
            ["0.50-0.99", "35"],
            ["1.00-1.99", "40"],
            ["2.00-2.99", "50"],
            ["3.00-4.99", "55"],
            ["5.00-9.99", "60"],
            ["10.00-19.99", "80"],
            ["20.00-49.99", "100"],
            ["50.00-99.99", "120"],
            ["100.00-199.99", "150"],
            ["200.00-499.99", "200"],
            ["500ct-1.00kg", "250"],
            ["Synthetic", "25"]
          ]
        },
        {
          name: "Other Colored Stone Report (loose)",
          type: "standard",
          headers: ["Carat weight", "Fee (€)"],
          rows: [
            ["≤1.99", "30"],
            ["2.00-4.99", "35"],
            ["5.00-19.99", "40"],
            ["20.00-49.99", "55"],
            ["50.00-99.99", "60"],
            ["100.00-199.99", "80"],
            ["200.00-499.99", "100"],
            ["≥500.00", "150"]
          ]
        }
      ]
    },
    {
      title: "Pearl Identification Report",
      tables: [
        {
          name: null,
          type: "standard",
          headers: ["Type", "Fee (€)"],
          rows: [
            ["1 Pearl", "35"],
            ["Pearl string", "110"],
            ["Double pearl string", "150"]
          ]
        }
      ]
    },
    {
      title: "Jewelry Identification Report",
      tables: [
        {
          name: null,
          type: "standard",
          headers: ["Type", "Fee (€)"],
          rows: [
            ["1 Diamond Jewelry", "Price of the diamond + 7"],
            ["Many Diamonds Jewelry ≤0.99", "47"],
            ["Many Diamonds Jewelry 1.00+", "Price of diamond lot + 7"],
            ["1 Colored Stone Jewelry", "Price of the colored stone + 7"],
            ["Many Colored Stones Jewelry", "Price of all colored stones + 7"],
            ["Mixed Stones Jewelry", "Price of diamonds + price of colored stones + 7"]
          ]
        }
      ]
    },
    {
      title: "Additional Services",
      tables: [
        {
          name: null,
          type: "additional",
          headers: ["Type", "Fee (€)"],
          rows: [
            ["Online Report", "Normal Price -2"],
            ["Large Report", "+10"],
            ["Luxury Report", "+30"],
            ["Premium Report", "+180"],
            ["Seal", "+6"],
            ["Laser Out (only Diamond)", "+10"],
            ["Laser In (only Diamond)", "+15"],
            ["Fancy Color (only Diamond)", "+15"],
            ["Duplicate", "15"],
            ["Recheck without Seal", "10"],
            ["Origin (Ruby, Sapphire, Emerald, Paraiba)", "+35"],
            ["Quick Check (Identification Only)", "10"],
            ["Emerald Clarity Enhancement Test", "20"],
            ["Video Service", "20"],
            ["Picture Service", "5/picture"],
            ["Colored Stone Lot (Uniform)", "Price of total carat weight + 5 for each extra stone"],
            ["Diamond Lot (2-3 stones, Uniform)", "Price of total carat weight + 5 for each extra stone"],
            ["Diamond Lot (≥4 stones, Uniform)", "45 for ≤ 1.00 ct + 5 for each extra carat"]
          ],
          highlightedRows: [
            ["Fast Service (next day) (No Origin)", "+50%"],
            ["Super-Fast Service (same day) (No Origin)", "+100%"]
          ]
        }
      ]
    }
  ]
};

export default priceListData;